// extracted by mini-css-extract-plugin
module.exports = {"adminInfo":"style-module__adminInfo___3ypb0"};